import Vue from 'vue'

const getDefaultState = () => {
    return {
        template: {
            id: 0,
            description: "",
            type: "",
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("quickbooks/template/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listTemplate = result.data.result;

                return listTemplate;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list template: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.template, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.template;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
